/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Embed_Captions_AriaInputs */



/**
* | output |
* | --- |
* | "Embed closed caption track into video" |
*
* @param {File_Export_Embed_Captions_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_embed_captions_aria = /** @type {((inputs?: File_Export_Embed_Captions_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Embed_Captions_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Incruster une piste de sous-titres dans la video")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertitel in das Video einbetten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Incorpora la traccia dei sottotitoli nel video")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Встроить субтитры в видео.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Incrustar pista de subtítulos en el vídeo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将字幕轨道嵌入视频")
	if (locale === "ja") return /** @type {LocalizedString} */ ("動画に字幕トラックを埋め込む")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो में क्लोज्ड कैप्शन ट्रैक एम्बेड करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Incorporar legendas ocultas no vídeo")
	return /** @type {LocalizedString} */ ("Embed closed caption track into video")
});